import React from "react"
import { NOTIFICATION_VIEW, NOTIFICATIONS_LIST_VIEW } from "./route-list"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"
const NotificationView = React.lazy(
  () =>
    import(
      "@/features/notifications/views/notification-view/notification-view"
    ),
)
const NotificationsPage = React.lazy(
  () =>
    import(
      "@/features/notifications/views/notifications-page/notifications-page"
    ),
)
const StandardLayout = React.lazy(
  () => import("@/layouts/bottom-menu-layout/bottom-menu-layout.tsx"),
)

const MOBILE_NO_MENU_LAYOUT_NOTIFICATION_ROUTES = {
  element: <NoMenuLayout />,
  children: [
    {
      path: NOTIFICATION_VIEW,
      element: <NotificationView />,
    },
  ],
}

const MOBILE_BOTTOM_MENU_LAYOUT_NOTIFICATION_ROUTES = {
  element: <StandardLayout />,
  children: [
    {
      path: NOTIFICATIONS_LIST_VIEW,
      element: <NotificationsPage />,
    },
  ],
}

const MOBILE_NOTIFICATION_ROUTES = [
  MOBILE_NO_MENU_LAYOUT_NOTIFICATION_ROUTES,
  MOBILE_BOTTOM_MENU_LAYOUT_NOTIFICATION_ROUTES,
]

const DESKTOP_NOTIFICATION_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: [
      {
        path: NOTIFICATIONS_LIST_VIEW,
        element: <NotificationsPage />,
      },
      {
        path: NOTIFICATION_VIEW,
        element: <NotificationView />,
      },
    ],
  },
]

export const getNotificationRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_NOTIFICATION_ROUTES : MOBILE_NOTIFICATION_ROUTES
}
